<template>
  <div id="trend-data-rooms">
    <div class="title-text sdf-text-20-400-white">
      ルーム種別
    </div>
    <div class="rooms-area">
      <div
        class="room-item-container"
        v-for="(room, index) in getRooms.m0_rooms" 
        :key="index" 
      >
        <div v-if="index > 0 && getRooms.m0_rooms[index -1].is_checked_weekly !== room.is_checked_weekly" class="room-separator"></div>
        <div
          class="room-item"
          :class="{
            'last-item':index == getRooms.m0_rooms.length-1,
            'first-item':index == 0,
            selected: room.room_id === getSelectedRoomId}"
        >
          <p
            @click="setSelectedRoomId(room.room_id)"
            class="room-text"
            :class="[room.room_id === getSelectedRoomId ? 'sdf-text-18-700-blue' : 'sdf-text-18-400-white']">{{room.room_name}}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {createNamespacedHelpers} from "vuex"
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
const { mapGetters, mapActions } = createNamespacedHelpers("checklistTrendDataReport")

export default {
  name: "trendDataRooms",
  mixins: [SecureDataflowMixin],
  data: function () {
    return {
    }
  },
  computed: {
    ...mapGetters(["getRooms", "getSelectedRoomId"]),
  },
  methods: {
    ...mapActions(["setSelectedRoomId"]),
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/secure-dataflow/_variables.scss";

#trend-data-rooms {
  background-color: $sdf-blue-gray;
  padding-left: 30px;
  color: $sdf-white;
  display: flex;
  align-items: center;
}

.rooms-area {
  display: flex;
  overflow-x: scroll;
  width: 100%;
  height: 54px;
  align-items: center;
}

.room-item-container {
  display: flex;
  align-items: center;
}

.room-item {
  height: 54px;
  font-size: 16px;
  margin-left: 20px;
  margin-right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.first-item {
  margin-left: 0px;
}

.room-separator {
  border-right: 1px solid;
  height: 30px;
}

.room-text:hover {
  color: $sdf-blue;
}

.selected {
  padding-top: 4px;
  color: $sdf-blue;
  border-bottom: solid 4px;
}

.room-text {
  font-size: 20px;
  cursor: pointer;
  white-space: nowrap;
}

.title-text {
  padding-top: 12px;
  padding-bottom: 12px;
  min-width: 220px;
}
</style>
